<template>
  <div>
    <router-view v-show="$route.matched.length==3"></router-view>
    <PageHeaderLayout v-show="$route.matched.length==2">
      <div class="main-page-content">
        <div class="main-content">
          <el-row>
            <el-col :span="12">
              <div>
                <div>
                  <div class="title three">公&nbsp;司&nbsp;名:</div>
                  <div class="desc">{{obj.name}}</div>
                </div>
                 <div>
                  <div class="title">
                    打款户名:
                  </div>
                  <div class="desc">
                   {{obj.account}}
                  </div>
                </div>
                <div>
                  <div class="title">
                    打款账户:
                  </div>
                  <div class="desc">
                    {{obj.bank}}
                  </div>
                </div>
                <div>
                  <div class="title">
                    打款开户行:
                  </div>
                  <div class="desc">
                    {{obj.bank_name}}
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </PageHeaderLayout>
  </div >
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'

export default {
  components: {
    PageHeaderLayout,
  },
  data() {
    return {
      obj: {}
    }
  },
  methods: {
    //获取账号信息
    async getInfo() {
      let info = await this.$api.getTenantDetail()
      this.obj= info
    },
  },
  mounted() {
    this.getInfo()
  }
}
</script>

<style lang="stylus" scoped>
  .title
    height: 45px
    color: rgba(97, 94, 94, 1)
    font-size: 18px
    line-height: 65px
  .main-content
    width: 980px
    margin: 50px
  .desc,
  .descOne
    color: rgba(28, 16, 1, 1)
    font-size: 18px
    text-align: left
    margin-left: 100px
  .desc
    height: 59px
    line-height: 59px
  .descOne
    height: 163px
    line-height 120px
    left: 1066px
    color: rgba(255, 149, 2, 1)
    font-size: 72px
  .descLast
    color: rgba(28, 16, 1, 1)
    font-size: 72px
    margin-left: 100px
  .tax
    word-spacing: 25px
  .three
    word-spacing: 5px
  .info
    float: right
  .last-item
    display: flex
    margin-top: 50px
  .switch
    margin-left: 15px
    line-height: 65px
  .early-warning
    line-height: 65px
    display: flex
  .update-btn
    margin-left: 10px
    margin-top: -4px
  .price-wrapper
    display: flex
    justify-content: center
    flex-direction: column
  .iconprice
    color: #e6a23c
    font-size: 25px
    margin-top: 2px
  .warning-tips
    padding: 15px 20px
    font-size: 16px
  .price-form
    margin: 50px 35px 0
  /deep/.price-wrapper .el-alert--warning.is-light .el-alert__description
    font-size: 15px
    margin-top: -2px
</style>
